import { ReactElement, useEffect, useState } from 'react';
import { getChooseYourPlanBoostValue } from 'utils/ab-test/abTests';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './ProgressBar.module.css';

interface Props {
  /** @deprecated No longer needed, as we have chosen a winner */
  variant?: string;
  /** The number of the step that we are currently on. This starts from 1, rather than zero */
  progressBars: number;
  /** @deprecated The total number of bars, however, the variant designs call for a fixed number of named steps */
  numBars?: number;
  /** @deprecated The children to show if the components own variant are not required. This prop won't be needed once
   * we stop using plasmic
   */
  children?: ReactElement;
  /** @deprecated Remove the margin, e.g. when used on EnterLayout. This should be deleted once enter flow is out of plasmic  */
  noBottomMargin?: boolean;
}

const steps = [
  { name: 'Numbers', iconFilename: 'enter-1.svg' },
  { name: 'Days', iconFilename: 'enter-2.svg' },
  { name: 'Boost', iconFilename: 'enter-3.svg' },
  { name: 'Sign up', altName: 'Sign in', iconFilename: 'enter-4.svg' },
  { name: 'Payment', iconFilename: 'enter-5.svg' },
];

const variants = {
  numbers: 'VARIANT1',
  icons: 'VARIANT2',
  ticks: 'VARIANT3',
};

const EnterProgressBar = (props: Props) => {
  const isNumbers = true;
  const isIcons = false;
  const isTicks = false;

  // The group is only knowable in the browser, so it is read after mount to keep the server and client renders in sync
  const [hidesBoostStep, setHidesBoostStep] = useState(false);
  useEffect(() => {
    setHidesBoostStep(getChooseYourPlanBoostValue() === 'ORIGINALV2');
  }, []);

  const stepsToUse = hidesBoostStep
    ? steps.filter((x) => x.name !== 'Boost')
    : steps;

  // The boost step is gone for this group, so everything after it moves back one
  const progressBarToUse =
    hidesBoostStep && props.progressBars >= 3
      ? props.progressBars - 1
      : props.progressBars;

  return (
    <div
      className={styles.stepContainerOuter}
      style={{ ['--stepContainerTotalSteps' as any]: stepsToUse.length }}
    >
      <div
        className={`${styles.stepContainer} ${props.noBottomMargin ? styles.noBottomMargin : ''} ${isNumbers ? styles.numbers : ''} ${isIcons ? styles.icons : ''} ${isTicks ? styles.ticks : ''} ${styles['stepIndex__' + progressBarToUse]}`}
      >
        {stepsToUse.map((x, index) => {
          return (
            <div
              key={index}
              className={`${styles.step} ${index >= progressBarToUse ? styles.upcoming : ''}`}
            >
              <div className={styles.circle}>
                {isNumbers ? (
                  index + 1
                ) : isIcons ? (
                  <img
                    src={ASSET_PREFIX + '/images/enter/2025/' + x.iconFilename}
                  />
                ) : (
                  <img
                    src={ASSET_PREFIX + '/images/enter/2025/enter-tick.svg'}
                  />
                )}
              </div>
              {isNumbers && <div className={styles.label}>{x.name}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Replace the default export with this line to see all variants at once
//    export default (props: Props) => <div style={{ width: "100%" }}>{Object.values(variants).map(x => <EnterProgressBar {...props} variant={x} />)}</div>;
export default EnterProgressBar;
